import styled from "styled-components";
import NoDataFoundImg from "../../assets/images/icons/no-data-icon.png";
import colors from "../../theme/color/ColorTheme";

const Wrapper = styled.div`
  width: fit-content;
  display: flex;
  align-items: flex-end;
  img {
    width: auto;
    margin: auto;
    height: 300px;
  }
  color: ${colors.textMuted};
`;
const Content = styled.div``;
function NotFoundError({ message }) {
  return (
    <Wrapper>
      <Content>
        <img src={NoDataFoundImg} alt="No Data Found" width={"auto"} />
        <p>{message}</p>
      </Content>
    </Wrapper>
  );
}

export default NotFoundError;
